import axios from 'axios'     //引入
import { Dialog } from 'vant';
import router from './../router'

// 生产环境使用当前站点的同源 /api 反向代理，避免手机端跨域失败。
let baseURL = window.location.origin
 
try {
  sessionStorage.setItem("baseURL", baseURL)
} catch (e) {
  // 部分手机内置浏览器可能禁用 sessionStorage，不影响接口请求。
}

//这一步的目的是判断出当前是开发环境还是生成环境，方法不止一种，达到目的就行
if(process.env.NODE_ENV=="development"){
  baseURL=''
}

let config = {
    baseURL: baseURL,
    timeout: 10000       //设置最大请求时间，减少等待时间
}
const _axios = axios.create(config)

/* 请求拦截器（请求之前的操作） */
_axios.interceptors.request.use(
    config => {
        //如果有需要在这里开启请求时的loading动画效果
        // Authorization:Bearer hPxf6a8TQnCkExTYxceujYgXoW9GXB9909zsZtpvabw6yO9ngcMVKgLx4mzD
        let token = sessionStorage.getItem('token') || ''
        if (token) {
            config.headers.Authorization = 'Bearer ' + token;
        }
        return config;
    },
    err => Promise.reject(err)
);

/* 请求之后的操作 */
_axios.interceptors.response.use(
    res => {
        //在这里关闭请求时的loading动画效果
        //这里用于处理返回的结果，比如如果是返回401无权限，可能会是跳回到登录页的操作，结合自己的业务逻辑写

        if (res.data.code === 401) {
            Dialog.alert({
                title: '认证失败',
                message: '您的账号登陆过期，请重新登陆',
              }).then(() => {
                localStorage.clear();
                sessionStorage.clear();
                router.replace('/login');
              });
        }
        return res;
    },
    err => {
        if (err) {
            //在这里关闭请求时的loading动画效果
            // Toast("请求网络失败")
        }
        return Promise.reject(err);
    }
);

//封装post,get方法
const http = {
    get(url = '', params = {}) {
        return new Promise((resolve, reject) => {
            _axios({
                url,
                params,
                method: 'GET'
            }).then(res => {
                resolve(res.data)
                return res
            }).catch(error => {
                reject(error)
            })
        })
    },
    post(url = '', params = {}, options = {}) {
        return new Promise((resolve, reject) => {
            const isForm = (typeof FormData !== 'undefined') && (params instanceof FormData)
            const headers = Object.assign({}, options.headers || {})
            // FormData 交给浏览器自动带 multipart boundary，不要手工指定 Content-Type
            if (isForm && headers['Content-Type']) {
                delete headers['Content-Type']
            }
            _axios({
                url,
                data: params,
                method: 'POST',
                headers,
                timeout: options.timeout || (isForm ? 30000 : undefined)
            }).then(res => {
                resolve(res.data)
                return res
            }).catch(error => {
                reject(error)
            })
        })
    }
}


export default http



// WEBPACK FOOTER //
// ./src/http/http.js